module.exports = __webpack_public_path__ + "static/media/combo-on-maroon-palpation-pad-mobile.f670cfe5.png";